module.exports = __webpack_public_path__ + "static/media/diamond.64dbd537.svg";